import React from 'react';
import PropTypes from 'prop-types';
import UserAvatar from "../Atoms/Templates/UserAvatar";
import Icon from "../Atoms/Icon";

const DischargedEmployee = props => {
  return (
    <article className="s-mb-0 normal-radius">
      <header className="s-main-justify nowrap s-mb-4px">
        <div className="s-cross-center">
          <UserAvatar className="s-mr-8px"/>
          <div>
            <p className="s-mb-0 small">José Antonio Arias Montaño</p>
            <p className="s-mb-0 s-color-light-text smaller">
              <span>78945612</span> - <span>HHRR</span>
            </p>
          </div>
        </div>
        <div className="s-cross-start"
          role="button"
          aria-pressed="false">
          <div className="hover-change s-pxy-4px normal-radius cursor-pointer s-cross-center s-main-center">
            <Icon svg="cross"/>
          </div>
        </div>
      </header>

      <div className="s-main-justify smaller s-mb-4px">
        <p className="s-mb-0">Aquí va el motivo</p>
        <time>24 de junio del 2020</time>
      </div>
      <p className="smaller s-mb-0 s-color-light-text">Por exceso de personal no se renovó el contrato de Pedro Torres
        Iturralde</p>

    </article>
  );
};

DischargedEmployee.propTypes = {};

export default DischargedEmployee;
